function onIntersection(onLoad) {
  return function (entries, observer) {
    const firstIntersection = entries.find(entry => entry.isIntersecting);

    if (!firstIntersection) {
      return;
    }

    const googleMaps = document.querySelector("script[data-google-maps]");

    if (!googleMaps) {
      return;
    }

    googleMaps.src = googleMaps.dataset.src;
    ["src", "googleMaps"].forEach(attr => { delete googleMaps.dataset[attr]; });

    if (onLoad) {
      googleMaps.addEventListener("load", onLoad);
    }

    observer.unobserve(firstIntersection.target);
  };
}

export default function lazyLoadMap(onLoad) {
  const map = document.querySelector("[data-google-map]");

  if (!map) {
    return;
  }

  const onintersection = onIntersection(onLoad);
  const intersectionObserver = new IntersectionObserver(
    onintersection,
    {
      root: null,
      rootMargin: "200px 0px",
      threshold: 0
    }
  );

  intersectionObserver.observe(map);
}



// WEBPACK FOOTER //
// ./shared/helpers/map_loader.js